import React, { useContext, useEffect, useState } from 'react';
import { Box, Button, Stack, Typography, useMediaQuery } from '@mui/material';
import { AuthenticationContext } from '../../components/authentication/AuthenticationContext';
import noizillaLogo from '../../assets/Noizilla-logo.png';
import { postAuthorize } from '../../components/apis/music-api';
import queryString from 'query-string';
import { useSearchParams  } from 'react-router-dom';

const RedirectUrl = process.env.REACT_APP_REDIRECT_URL || '';

const Home = () => {
  const { setTokenResponse } = useContext(AuthenticationContext);
  const [ message, setMessage ] = useState('');
  const [ code, setCode ] = useState('');
  const { isAuthenticated, login } = useContext(AuthenticationContext);
  // eslint-disable-next-line
  const [ searchParams, setSearchParams ] = useSearchParams();
  const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  
  const removeCodeParam = () => {
    setSearchParams({});
    window.location.href = RedirectUrl;
  }

  const authenticate = async (code: string) => {
    try
    {
      const tokenResponse = await postAuthorize(code);
      setTokenResponse(tokenResponse);
      removeCodeParam();
    }
    catch (ex)
    {
      setMessage('Unable to login');
    }
  }
  
  useEffect(() => {
    const queryStringParams = queryString.parse(window.location.search);
    if (queryStringParams?.code !== null) {
      setCode(queryStringParams?.code?.toString());
    }
  }, []);
  
  useEffect(() => {
    var latestCode = localStorage.getItem("AuthorizationCode");
    const isAuth = isAuthenticated();
    if (!isAuth && code && code !== latestCode) {
      authenticate(code);
    }

    if (isAuth) {
      setMessage('Welcome to Noizilla!');
    }
  // eslint-disable-next-line
  }, [code, setTokenResponse]);
  
  return (
    <Stack sx={{ textAlign: 'center' }} spacing={2}>  
      <Box
          display="flex"
          justifyContent="center"
          alignItems="center">
          <Typography variant="h5">{message}</Typography>
      </Box>        
      <Box>
        <Box
          component="img"
          src={noizillaLogo}
          sx={{ width: isSmall ? '100%' : '347px' }}
        />
      </Box>
      <Box>
        {isAuthenticated() === false && <Button onClick={login} variant='contained'>Login</Button>}
      </Box>
    </Stack>
  );
}

export default Home;